import { View } from 'react-native';

import colors from 'config/colors';
import Text, { TextProps } from 'components/Text';

type HasUnacceptChangesLabelProps = Partial<TextProps> & {
  fullWidth?: boolean;
};

export function HasUnacceptChangesLabel(props: HasUnacceptChangesLabelProps) {
  const { style, fullWidth, ...restProps } = props;
  return (
    <View
      style={[
        {
          justifyContent: 'center',
          alignItems: 'center',
          width: fullWidth ? 'auto' : 84,
          height: 84,
          marginHorizontal: 4,
        },
        style,
      ]}
    >
      <Text
        font={'bold'}
        align={'center'}
        color={colors.text.dark}
        id={'notifications.hasUnacceptedChanges'}
        size={12}
        {...restProps}
      />
    </View>
  );
}
